import resetPasswordWithToken from '../../models/User/resetPasswordWithToken'
import { toast } from 'react-toastify'
import Toast from '../../containers/Toast'
import React from 'react'
import i18n from '../../i18n'
import authorize from '../../actions/userAccount/authorize/authorize'
import { Mixpanel } from '../../utils/Mixpanel'

export default function(values: any, dispatch: any, props: any) {
  resetPasswordWithToken(values)
    .then(() => {
      if (values.employee) {
        Mixpanel.track('Employees List Reset Password Complete', {
          'Employee ID': values.employee,
        })
      }
      if (values.first) {
        Mixpanel.track('Employee List New Employee Create Password Completed', {
          'Employee ID': values.employee,
        })
      }

      toast(
        <Toast.Success>
          {i18n.t('OUT_4234_password_change_confirmation')}
        </Toast.Success>,
        {
          autoClose: 5000,
          className: 'success-background',
          containerId: 'Main',
          toastId: 'BBO_3914_password_recovery_success',
        },
      )
      dispatch(authorize(values.email, values.password))
    })
    .catch(e => {
      toast(<Toast.Error>{i18n.t('errStatus_8')}</Toast.Error>, {
        autoClose: 5000,
        className: 'error-background',
        containerId: 'Main',
        toastId: 'errStatus_8',
      })
    })
}
